import React from "react";
import group1 from "../../images/Group (1).png";
import { Link } from "react-router-dom";
import icon1 from "../../images/1.png";
import icon2 from "../../images/2.png";

const FeatureCards_WelcomeSection = () => {
  const features = [
    {
      icon: icon1,
      title: "Convert text to speech",
      description: "Try out the APIs for text to speech conversions.",
      arrow:
        "https://dashboard.codeparrot.ai/api/image/Z6-UCeepongUSRkY/arrow-2.png",
      try: "Coming Soon...",
    },
    {
      icon: icon2,
      title: "Transcribe speech to text",
      description: "Try out the APIs for speech to text translations.",
      arrow:
        "https://dashboard.codeparrot.ai/api/image/Z6-UCeepongUSRkY/arrow-3.png",
      try: "Coming Soon...",
    },
  ];

  return (
    <div className="w-full min-h-[300px] px-4 relative">
      <div className="max-w-[1162px] mx-auto flex flex-col gap-12">
        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 md:gap-12">
          {features.map((feature, index) => (
            <div
              key={index}
              className="relative bg-white rounded-2xl shadow-md hover:shadow-lg transition-shadow border border-gray-100 overflow-hidden"
            >
              <div className="p-8 flex flex-col justify-between items-center min-h-[231px]">
                <div className="flex flex-col gap-4 justify-between items-center">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center bg-gray-50 border border-gray-100">
                    <img src={feature.icon} alt="" className="w-9 h-9" />
                  </div>
                  <h2 className="text-[22px] font-bold text-[#10281e] text-center">
                    {feature.title}
                  </h2>
                  <p className="text-base text-[#282d2b] text-center max-w-sm">
                    {feature.description}
                  </p>
                </div>
                {feature.href ? (
                  <Link
                    to={feature.href}
                    className="flex items-center gap-1 text-[#099838] hover:opacity-80 transition-opacity mt-4 font-semibold"
                  >
                    {feature.try}
                    <img src={feature.arrow} alt="" className="w-3 h-3" />
                  </Link>
                ) : (
                  <span className="inline-flex items-center gap-1 text-[#099838] font-semibold text-sm bg-green-50 border border-green-200 px-4 py-1.5 rounded-full mt-4">
                    {feature.try}
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      <img
        src={group1}
        alt="Left decoration"
        className="absolute left-0 transform -translate-y-1/2 w-16 md:w-24 pointer-events-none opacity-80"
      />
    </div>
  );
};

export default FeatureCards_WelcomeSection;